export const ptBR = {
  // Nav
  dashboard: 'Painel',
  simulations: 'Simulações',
  assessment: 'Avaliação',
  organization: 'Organização',
  history: 'Relatórios',
  newOrganization: 'Nova Organização',
  profile: 'Perfil',
  settings: 'Configurações',
  logout: 'Sair',
  user: 'Usuário',
  menu: 'Menu',

  // Search
  search: 'Buscar',
  searchPlaceholder: 'Buscar no SecureCoop...',
  pressEnterToSearch: 'Pressione Enter para buscar',
  searchSuggestions: ['phishing', 'engenharia social', 'painel', 'histórico', 'avaliação', 'organização', 'força bruta', 'relatório'],

  // Notifications
  notifications: 'Notificações',
  noNotifications: 'Nenhuma notificação',
  unread: 'não lida',
  unreadPlural: 'não lidas',

  // Time
  now: 'agora',
  minutesAgo: 'há {n} min',
  hoursAgo: 'há {n}h',
  daysAgo: 'há {n} dia',
  daysAgoPlural: 'há {n} dias',

  // Settings
  preferences: 'Preferências da interface',
  themeMode: 'Modo do tema',
  lightTheme: 'Tema Claro',
  darkTheme: 'Tema Escuro',
  language: 'Idioma',
  interfaceAnimations: 'Animações da interface',
  animationDesc: 'Transições e efeitos visuais',
  notificationsSetting: 'Notificações',
  notificationsDesc: 'Alertas e avisos do sistema',
  demoTools: 'Ferramentas de demonstração',
  demoToolsDesc: 'Útil para resetar dados durante apresentações.',
  resetSimulationData: 'Resetar Dados de Simulação',
  confirmReset: 'Confirmar reset de dados?',
  close: 'Fechar',
  attention: 'Atenção',

  // Profile modal
  manageInfo: 'Gerencie suas informações',
  profilePhoto: 'Foto do perfil',
  uploadNewPhoto: 'Enviar nova foto',
  removePhoto: 'Remover foto',
  name: 'Nome',
  email: 'E-mail',
  yourName: 'Seu nome',
  emailReadonly: 'O e-mail não pode ser alterado',
  accountSecurity: 'Segurança da conta',
  changePassword: 'Alterar senha (opcional)',
  currentPassword: 'Senha atual',
  newPassword: 'Nova senha',
  confirmPassword: 'Confirmar nova senha',
  cancel: 'Cancelar',
  save: 'Salvar',
  saving: 'Salvando...',
  photoPreview: 'Prévia da foto',
  errorCurrentPassword: 'Informe a senha atual para alterar.',
  errorPasswordsMismatch: 'As senhas não coincidem.',
  errorPasswordMin: 'A nova senha deve ter pelo menos 6 caracteres.',
  successPhotoUpdated: 'Foto atualizada com sucesso.',
  successProfileUpdated: 'Perfil atualizado com sucesso.',
  successProfilePasswordNote: 'Perfil atualizado. A alteração de senha requer suporte do backend.',
  errorSaving: 'Erro ao salvar.',

  // Auth
  signIn: 'Entrar',
  signInProgress: 'Entrando...',
  createAccount: 'Criar conta',
  signUp: 'Cadastrar',
  signUpProgress: 'Cadastrando...',
  noAccount: 'Não tem conta?',
  hasAccount: 'Já tem conta?',
  signUpLink: 'Cadastre-se',
  signInLink: 'Entrar',
  password: 'Senha',
  minChars: 'Mínimo 6 caracteres',
  securityPlatform: 'Plataforma de Conscientização em Segurança',

  // Home
  welcome: 'Gerencie a segurança da sua organização',
  welcomeDesc: 'Simule ataques, identifique riscos e fortaleça sua equipe com dados reais.',
  accessDashboard: 'Acessar Painel',
  createOrganization: 'Criar Organização',

  // Dashboard
  dashboardTitle: 'Painel de Conscientização em Segurança',
  dashboardSubtitle: 'Visão geral da segurança e conscientização da sua organização',
  securityOverview: 'Visão Geral de Segurança',
  humanRiskScore: 'Índice de Risco Humano',
  simulationsExecuted: 'Simulações Executadas',
  vulnerabilitiesDetected: 'Vulnerabilidades Detectadas',
  riskAnalysis: 'Análise de Risco',
  phishingRisk: 'Risco de Phishing',
  socialEngineeringRisk: 'Risco de Engenharia Social',
  authorityFraudRisk: 'Risco de Fraude de Autoridade',
  recentActivity: 'Atividade Recente',
  recentActivitySubtitle: 'Últimas atividades de simulação',
  quickActions: 'Ações Rápidas',
  quickActionsSubtitle: 'Acesso rápido às simulações',
  startPhishingSim: 'Iniciar Simulação de Phishing',
  startSocialEngineeringSim: 'Iniciar Simulação de Engenharia Social',
  startBruteForceSim: 'Iniciar Simulação de Força Bruta',
  startSocialEngineeringChat: 'Iniciar chat de Engenharia Social',
  noRecentActivity: 'Nenhuma atividade recente',
  runSimulationsToSee: 'Execute simulações para ver as atividades aqui.',
  goToSimulations: 'Ir para Simulações',
  criticalVulnerabilities: 'Vulnerabilidades Críticas',
  noCriticalVulns: 'Nenhuma vulnerabilidade crítica no momento.',
  recentAssessments: 'Avaliações Recentes',
  lastAssessment: 'Última avaliação',
  none: 'Nenhuma',
  viewReport: 'Ver relatório',
  noAssessments: 'Nenhuma avaliação realizada.',

  // Simulations
  attackSimulations: 'Simulações de Ataque',
  simulationsSubtitle: 'Execute simulações para entender como ataques comuns funcionam e acompanhe seu perfil de risco.',
  riskOverview: 'Visão Geral de Risco de Segurança',
  riskOverviewSubtitle: 'Resumo do risco humano com base nas simulações realizadas',
  runSocialEngineeringForScore: 'Execute simulações de Engenharia Social para calcular seu índice',
  availableSimulations: 'Simulações disponíveis',
  phishing: 'Phishing',
  phishingDesc: 'Simula um ataque de phishing por e-mail',
  socialEngineering: 'Engenharia Social',
  socialEngineeringDesc: 'Simula cenários de Engenharia Social em formato de chat',
  bruteForce: 'Força Bruta',
  bruteForceDesc: 'Simula tentativas de acesso por força bruta e avalia bloqueio de conta, rate limiting e exposição por senha fraca.',
  lastRun: 'Última execução',
  startSimulation: 'Iniciar Simulação',
  starting: 'Iniciando...',
  simulationComplete: 'Simulação concluída',
  phishingSimComplete: 'Demonstração de cenário de phishing concluída',
  socialEngineeringSimComplete: 'Simulação de Engenharia Social concluída',
  bruteForceSimComplete: 'Simulação de força bruta concluída',
  simulationDetails: 'Detalhes da simulação',
  simulationOf: 'Simulação de',
  executedAt: 'Executada em',
  by: 'por',
  timeline: 'Linha do tempo',
  timelineTimesIllustrative: 'Os horários dos passos são ilustrativos para visualização didática da sequência da simulação.',
  bruteForceResultTitle: 'Resultado dos controles de autenticação',
  controlsStatus: 'Status dos controles',
  simulatedAttempts: 'Tentativas simuladas',
  blockThreshold: 'Limite para bloqueio',
  bruteForceOutcomeBlocked: 'Bloqueado',
  bruteForceOutcomeRateLimited: 'Limitado por taxa',
  bruteForceOutcomeSuccess: 'Comprometimento simulado',
  bruteForceOutcomeIndeterminate: 'Inconclusivo',
  bruteForceLabTitle: 'Laboratório de Força Bruta',
  bruteForceLabSubtitle: 'Teste uma senha de exemplo e veja o impacto em risco, tempo de quebra e tentativas.',
  bruteForceLabHowItWorks: 'Como funciona',
  bruteForceLabHowItWorksSubtitle: 'A senha é avaliada localmente no navegador e apenas métricas são salvas no histórico.',
  bruteForceLabWarning: 'Use apenas uma senha fictícia para treinamento. Nunca informe senha real.',
  bruteForceLabPasswordInputLabel: 'Senha de teste',
  bruteForceLabPasswordInputPlaceholder: 'Ex.: Coop@123',
  bruteForceLabEstimatedResult: 'Resultado estimado do laboratório',
  bruteForceLabEstimatedResultSubtitle: 'Estimativas educacionais para ajudar na conscientização de segurança.',
  bruteForceLabSavedToHistory: 'Resultado salvo no histórico de simulações.',
  passwordStrengthLevel: 'Nível da senha',
  passwordEntropyBits: 'Entropia (bits)',
  timeToCrackRateLimited: 'Tempo para quebrar (com rate limiting)',
  timeToCrackNoRateLimit: 'Tempo para quebrar (sem rate limiting)',
  timeToCrackOfflineLeak: 'Tempo para quebrar (vazamento offline)',
  simulatedOutcome: 'Outcome simulado',
  strengthLOW: 'Fraca',
  strengthMEDIUM: 'Média',
  strengthHIGH: 'Forte',
  strengthVERY_HIGH: 'Muito forte',
  outcomeBLOCKED: 'Bloqueado',
  outcomeRATE_LIMITED: 'Limitado por taxa',
  outcomeSUCCESS: 'Comprometido',
  outcomeINDETERMINATE: 'Inconclusivo',
  lessThanSecond: '< 1s',
  moreThanCentury: '> 100 anos',
  moreThanMonth: '> 30 dias',
  runningSimulation: 'Executando simulação...',
  errorRunningBruteForceLab: 'Erro ao executar o laboratório de força bruta.',
  bruteForcePolicyBlocked: 'Bloqueio de conta e monitoramento de tentativas impediram o acesso não autorizado.',
  bruteForcePolicyRateLimited: 'Rate limiting reduziu o volume de tentativas, mas sem bloqueio total da conta.',
  bruteForcePolicySuccess: 'A senha é vulnerável em cenários sem controles eficazes.',
  bruteForcePolicyIndeterminate: 'Há controles parciais, mas o risco ainda exige reforço de segurança.',
  bruteForceOverlayTitle: 'Simulação de ataque em andamento',
  bruteForceOverlaySubtitle: 'Demonstração visual didática de tentativas automatizadas.',
  bruteForceOverlayProgress: 'Progresso da simulação',
  bruteForceOverlayHeaderLine: '[SecureCoop] Inicializando motor de simulação de força bruta...',
  bruteForceOverlayInitLine: '> Conectando ao endpoint de autenticação simulado...',
  bruteForceOverlayAttemptLine: '> Tentativa #{n}: validando credencial candidata',
  bruteForceOverlayRateLimitLine: '> Controle detectado: rate limiting ativado pelo sistema',
  bruteForceOverlayLockoutLine: '> Controle detectado: bloqueio temporário de conta aplicado',
  bruteForceOverlayCompromisedLine: '> Alerta: cenário simulado indica comprometimento de credenciais',
  bruteForceOverlayIndeterminateLine: '> Resultado parcial: controles presentes, risco residual ainda relevante',
  bruteForceOverlayFinishedLine: '> Finalizando simulação e consolidando métricas...',
  overlayStatusTrying: 'Tentando combinações',
  overlayStatusRateLimited: 'Rate limiting detectado',
  overlayStatusBlocked: 'Bloqueio detectado',
  overlayStatusCompromised: 'Comprometimento simulado',
  overlayStatusAnalyzing: 'Consolidando resultado',
  bruteForceEventRecon: 'Reconhecimento do serviço e política de autenticação',
  bruteForceEventReconImpact: 'Coleta de superfície exposta para tentativa automatizada',
  bruteForceEventAttempts: 'Execução automatizada de {n} tentativas simuladas',
  bruteForceEventAttemptsImpact: 'Volume de tentativa compatível com cenário de força bruta',
  bruteForceEventControlBlocked: 'Controle aplicado: bloqueio temporário de conta',
  bruteForceEventControlRateLimited: 'Controle aplicado: limitação de taxa de tentativas',
  bruteForceEventControlWeak: 'Controles frágeis: ausência de bloqueio/rate limit efetivo',
  bruteForceEventControlPartial: 'Controles parciais detectados durante a simulação',
  bruteForceEventControlImpact: 'Avaliação dos mecanismos de defesa de autenticação',
  bruteForceEventOutcomeBlocked: 'Resultado final: ataque simulado bloqueado',
  bruteForceEventOutcomeRateLimited: 'Resultado final: ataque reduzido por rate limiting',
  bruteForceEventOutcomeCompromised: 'Resultado final: comprometimento simulado de credencial',
  bruteForceEventOutcomeIndeterminate: 'Resultado final: risco residual inconclusivo',
  bruteForceEventOutcomeImpact: 'Consolidação do impacto do cenário simulado',
  bruteForceDetailsDefaultSummary: 'Resumo indisponível para esta execução. Consulte os eventos na linha do tempo.',
  estimatedCrackTime: 'Tempo estimado de quebra',
  simulationHistory: 'Histórico de Simulações',
  simulationHistorySubtitle: 'Todas as simulações executadas nesta organização',
  noSimulationsYet: 'Nenhuma simulação executada ainda',
  runFirstSimulation: 'Execute sua primeira simulação para avaliar o risco humano.',
  viewSimulations: 'Ver simulações',
  type: 'Tipo',
  date: 'Data',
  executedBy: 'Executado por',
  action: 'Ação',
  viewDetails: 'Ver detalhes',
  backToSimulations: 'Voltar para Simulações',

  // Simulation intros
  phishingSimIntro: 'Simulação de Phishing',
  socialEngineeringSimIntro: 'Simulação de Engenharia Social',
  understandBeforeStart: 'Entenda como funciona antes de iniciar.',
  whatWillBeSimulated: 'O que será simulado',
  phishingIntroSubtitle: 'Treinamento de identificação de e-mail malicioso',
  socialEngineeringIntroSubtitle: 'Treinamento de engenharia social em conversa guiada',
  prerequisites: 'Pré-requisitos',
  phishingPrerequisitesText: 'Use apenas e-mail autorizado por você e execute em ambiente de treinamento.',
  socialEngineeringPrerequisitesText: 'Reserve alguns minutos para concluir o cenário e responder com atenção em cada etapa.',
  phishingSimDesc: 'Esta simulação envia um e-mail de phishing para o endereço que você informar. O sistema irá acompanhar suas ações para avaliar sua conscientização em segurança.',
  phishingSimPoints: [
    'O sistema registra se o e-mail foi aberto',
    'O sistema registra se o link no e-mail foi clicado',
    'Ao final, você verá um resultado didático sobre o que teria acontecido em um ataque real',
  ],
  phishingAttention: 'Atenção: Use apenas seu próprio e-mail e autorize a simulação conscientemente. Esta ferramenta é para treinamento e conscientização.',
  socialEngineeringSimDesc: 'Esta simulação apresenta uma conversa em formato de chat com um atacante que tenta obter informações sensíveis ou induzir ações perigosas através de manipulação psicológica.',
  socialEngineeringSimPoints: [
    'Você verá mensagens do atacante (ex.: Suporte de TI, RH, Gestor)',
    'A cada mensagem, escolha como responderia na situação real',
    'O atacante reagirá conforme suas respostas, criando caminhos diferentes',
    'Ao final, receberá um feedback de treinamento sobre o que poderia acontecer em um ataque real',
  ],
  socialEngineeringScenarios: 'Os cenários incluem: Suporte de TI falso, RH/UGP pedindo validação de dados e gestor solicitando ação urgente. Respostas menos óbvias podem levar a ramificações diferentes na conversa.',
  startSimulationBtn: 'Iniciar Simulação',
  back: 'Voltar',

  // Phishing Manual
  manualPhishingSim: 'Simulação Manual de Phishing',
  manualPhishingDesc: 'Envie um e-mail de teste de phishing para seu próprio endereço para avaliar sua conscientização.',
  sendVerificationCode: 'Enviar código de verificação',
  verificationCodeSent: 'Código enviado! Verifique seu e-mail.',
  enterVerificationCode: 'Digite o código de 6 dígitos',
  verifyCode: 'Validar código',
  codeVerified: 'E-mail verificado. Agora você pode enviar a simulação.',
  sendSimulation: 'Enviar simulação',
  bypassVerification: 'Enviar sem verificação (usuário autorizado)',
  sendDirectly: 'Enviar diretamente',
  phishingAttentionManual: 'Esta simulação deve ser usada apenas para testes pessoais. Para uso corporativo ou simulações com colaboradores reais entre em contato.',
  yourEmail: 'Seu e-mail',
  emailPlaceholder: 'seu@email.com',
  confirmEmailAuth: 'Confirmo que este e-mail pertence a mim e autorizo o envio da simulação de phishing.',
  sendEmail: 'Enviar Email',
  sending: 'Enviando...',
  emailSentSuccess: 'E-mail enviado com sucesso!',
  emailSentDesc: 'Um e-mail de simulação foi enviado para {email}. Verifique sua caixa de entrada e clique no link para completar a simulação e ver o resultado.',
  mustConfirmEmail: 'Você deve confirmar que o e-mail é seu e autorizar a simulação.',

  // Phishing Result
  phishingResultTitle: 'Resultado da Simulação de Phishing',
  emailSent: 'E-mail enviado',
  emailOpened: 'E-mail aberto',
  linkClicked: 'Link clicado',
  securitySimulationNotice: 'Esta era uma simulação de segurança',
  phishingResultDesc: 'O e-mail que você recebeu fazia parte de um teste de conscientização. Em um ataque real de phishing, ao clicar no link e inserir suas credenciais, criminosos poderiam roubá-las e acessar suas contas. Sempre verifique o remetente e a URL antes de informar dados sensíveis.',
  thanksForParticipating: 'Obrigado por participar da simulação de segurança.',
  invalidLink: 'Link inválido',

  // Social Engineering Chat
  chatSimTitle: 'Simulação de Chat – Engenharia Social',
  chatSimDesc: 'Simule uma conversa com um atacante. Escolha suas respostas e veja o resultado do treinamento ao final.',
  selectScenario: 'Selecione um cenário',
  noScenariosAvailable: 'Nenhum cenário disponível',
  noScenariosDesc: 'Não há cenários de chat disponíveis no momento.',
  attacker: 'Atacante',
  startConversation: 'Iniciar conversa',
  trainingResult: 'Resultado do treinamento',
  safeChoice: 'Escolha segura',
  highRisk: 'Alto risco',
  yourChoices: 'Suas escolhas',
  newConversation: 'Nova conversa',
  howWouldYouRespond: 'Como você responde?',

  // Assessment
  securityAssessment: 'Avaliação de Segurança',
  assessmentDesc: 'Responda às perguntas para obter sua pontuação e identificar vulnerabilidades.',
  weight: 'Peso',
  category: 'Categoria',
  general: 'Geral',
  yes: 'Sim',
  no: 'Não',
  submitAssessment: 'Enviar Avaliação',
  submitting: 'Enviando...',

  // History
  assessmentHistory: 'Histórico de Avaliações',
  assessmentHistoryDesc: 'Todas as avaliações de segurança realizadas pela organização.',
  noAssessmentsFound: 'Nenhuma avaliação encontrada.',
  runAssessment: 'Realizar Avaliação',
  riskLevel: 'Nível de Risco',
  vulnerabilities: 'Vulnerabilidades',

  // Report
  securityReport: 'Relatório de Segurança',
  assessmentOf: 'Avaliação de',
  backToDashboard: 'Voltar ao Painel',
  securityScore: 'Pontuação de Segurança',
  of100Points: 'de 100 pontos',
  vulnerabilitiesDetectedTitle: 'Vulnerabilidades Detectadas',
  recommendation: 'Recomendação',
  noCriticalVulnerabilities: 'Nenhuma vulnerabilidade crítica',
  congratsNoVulns: 'Parabéns! Esta avaliação não identificou vulnerabilidades críticas.',
  securityRecommendations: 'Recomendações de Segurança',
  reportRecommendations: [
    'Realize avaliações de segurança periodicamente (recomendado: trimestralmente)',
    'Treine colaboradores sobre Phishing e Engenharia Social',
    'Implemente MFA em todos os acessos críticos',
    'Mantenha sistemas e antivírus atualizados',
    'Monitore e audite acessos ao sistema',
    'Estruture um plano de resposta a incidentes',
  ],
  reportNotFound: 'Relatório não encontrado.',

  // Organization
  organizationData: 'Dados da Organização',
  organizationUsers: 'Usuários da Organização',
  bypassPermission: 'Enviar simulação sem verificação',
  grantingBypass: 'Concedendo...',
  revokingBypass: 'Removendo...',
  userRole: 'Função',
  bypassAlways: 'sempre',
  employeesCount: 'Número de colaboradores',
  hasItTeam: 'Possui equipe de TI',
  hasSecurityPolicy: 'Possui política de segurança',
  createOrgTitle: 'Criar Organização',
  createOrgDesc: 'Cadastre sua cooperativa ou organização para iniciar as avaliações.',
  organizationName: 'Nome da organização',
  orgPlaceholder: 'Ex: Cooperativa ABC',

  // Risk labels
  low: 'BAIXO',
  medium: 'MÉDIO',
  high: 'ALTO',
  critical: 'CRÍTICO',

  // Relative date
  today: 'Hoje',
  yesterday: 'Ontem',

  // Search
  noResultsFound: 'Nenhum resultado encontrado',

  // History table
  score: 'Score',

  // Report severity
  severityLow: 'Baixa',
  severityMedium: 'Média',
  severityHigh: 'Alta',
  severityCritical: 'Crítica',

  // Notification demo messages
  notifSimulationComplete: 'Simulação concluída',
  notifPhishingClicked: 'Usuário clicou no link de phishing',
  notifSEDataShared: 'Dados sensíveis compartilhados em simulação de engenharia social',
  notifVulnerabilityDetected: 'Nova vulnerabilidade detectada',
  notifRiskUpdated: 'Score de segurança atualizado',

  // Activity timeline (simulation steps from backend)
  activityStepBrute1: 'Reconhecimento do sistema de autenticação',
  activityStepBrute2: 'Envio de múltiplas tentativas de senha',
  activityStepBrute3: 'Detecção de bloqueio ou rate limiting',
  activityStepBrute4: 'Resultado da simulação com base nos controles',
  activityStepPhishing1: 'E-mail falso enviado para colaboradores',
  activityStepPhishing2: 'Colaborador clica no link malicioso',
  activityStepPhishing3: 'Página de login falsa captura credenciais',
  activityStepPhishing4: 'Atacante obtém acesso ao sistema',
  activityStepSE1: 'Atacante identifica alvo e contexto',
  activityStepSE2: 'Contato inicial por telefone/email se passando por suporte',
  activityStepSE3: 'Persuasão para revelar informações sensíveis',
  activityStepSE4: 'Atacante utiliza informações para acesso não autorizado',

  // Critical vulnerability card
  vulnCriticalRiskPrefix: 'Risco crítico: ',
  vulnRecommendationDefault: 'Implemente as medidas necessárias para atender este requisito de segurança.',
  vulnQuestionMFA: 'A organização utiliza autenticação MFA (Multi-Fator)?',
  vulnQuestionLogin: 'O login é monitorado?',
  vulnQuestionSensitiveData: 'O acesso a dados sensíveis é controlado?',
  vulnQuestionIncidents: 'Existe processo de resposta a incidentes?',
  vulnQuestionEncryption: 'Dados sensíveis são criptografados?',
  vulnQuestionVPN: 'Acesso remoto é protegido com VPN?',
};
